import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";

const footerColumns = [
  {
    title: "ソリューション",
    links: [
      { label: "人材みえる化", href: "#top" },
      { label: "サービス一覧", href: "#services" },
      { label: "代表挨拶", href: "#message" },
    ],
  },
  {
    title: "導入をご検討の方",
    links: [
      { label: "資料ダウンロード", href: "#contact" },
      { label: "お問い合わせ", href: "#contact" },
      { label: "ストレスチェック", href: "#related-services" },
    ],
  },
  {
    title: "企業情報",
    links: [
      { label: "会社概要", href: "/company" },
      { label: "ニュース", href: "#top" },
      { label: "採用情報", href: "#top" },
      { label: "プライバシーポリシー", href: "/privacy-policy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 pt-14 md:pt-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-10 border-b border-white/10 pb-12 lg:flex-row lg:items-start lg:justify-between lg:gap-10">
          <div className="lg:w-[300px] lg:shrink-0">
            <a href="#top" className="flex items-center">
              <Logo
                className="h-[21px] md:h-[27px]"
                src="https://static.readdy.ai/image/913058b6efbc183fd3b03b474476e73a/32e004783178fd263c556725d0874e6a.png"
              />
            </a>
            <p className="mt-5 font-body text-xs leading-relaxed text-white/60 md:text-sm">
              採用・人材活用・組織づくりを
              <br className="hidden lg:block" />
              新しいテクノロジーと営業支援で
              <br className="hidden lg:block" />
              サポート
            </p>
          </div>

          <div className="flex flex-col gap-8 lg:flex-1">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-white">
                  <a href="#top">{column.title}</a>
                </h4>
                <ul className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2">
                  {column.links.map((link, index) => (
                    <li key={link.label} className="flex items-center gap-x-3">
                      {index > 0 && (
                        <span className="text-white/25" aria-hidden="true">
                          ／
                        </span>
                      )}
                      {link.href.startsWith("/") ? (
                        <Link
                          to={link.href}
                          className="font-body text-xs whitespace-nowrap text-white/60 transition-colors hover:text-white md:text-sm"
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <a
                          href={link.href}
                          className="font-body text-xs whitespace-nowrap text-white/60 transition-colors hover:text-white md:text-sm"
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-6 py-8 sm:flex-row">
          <p className="font-body text-xs text-white/50">
            © 2026 NAMBA Inc. All rights reserved.
          </p>
          <div className="flex flex-col items-center gap-5 sm:flex-row sm:items-center">
            <div className="flex items-center gap-5">
              <Link
                to="/terms"
                className="font-body text-xs text-white/50 transition-colors hover:text-white"
              >
                利用規約
              </Link>
              <Link
                to="/privacy-policy"
                className="font-body text-xs text-white/50 transition-colors hover:text-white"
              >
                プライバシーポリシー
              </Link>
              <Link
                to="/legal-notice"
                className="font-body text-xs text-white/50 transition-colors hover:text-white"
              >
                特定商取引法に基づく表記
              </Link>
            </div>
            <img
              src="https://public.readdy.ai/ai/img_res/3ed906d4-1f36-4b5e-9490-d005e87a1182.png"
              alt="NAMBA キャラクターロゴ"
              className="h-14 w-14 object-contain md:h-16 md:w-16"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}